import React from "react";
import image404 from "../../assets/img/error404.png";

function NotFound({ msg, img }) {
  return (
    // <div className="w-full h-full p-3 m-6 text-center bg-white rounded-3xl md:w-2/4 lg:p-10 md:h-3/4">
    <div className="w-full h-full p-3 m-6 text-center rounded-3xl md:w-2/4 lg:p-10 md:h-3/4">
      <div className="flex flex-col items-center justify-center">
        <h1 className="m-5 text-3xl font-bold text-center uppercase animate__zoomInDown animate__slower md:text-5xl text-saluta-p">
          {msg}
        </h1>
        <img
          className="w-full h-auto sm:w-3/5"
          src={img ?? image404}
          alt="Error"
        ></img>
      </div>
    </div>
  );
}

export default NotFound;
